import styled, { css } from 'styled-components';

import { ClassNamed, getSpacingToken, SpacingToken } from '@optimus-web/core';

interface Props {
    left?: boolean;
    right?: boolean;
    top?: boolean;
    bottom?: boolean;
    inline?: boolean;
    spacingToken: SpacingToken;
}

type FCClassnamed = React.FC<React.PropsWithChildren<ClassNamed>>;

const Spacing = styled.div`
    ${(props: Props) =>
        props.left &&
        css`
            padding-left: ${getSpacingToken(props.spacingToken)}px;
        `}
    ${(props: Props) =>
        props.right &&
        css`
            padding-right: ${getSpacingToken(props.spacingToken)}px;
        `}
    ${(props: Props) =>
        props.top &&
        css`
            padding-top: ${getSpacingToken(props.spacingToken)}px;
        `}
    ${(props: Props) =>
        props.bottom &&
        css`
            padding-bottom: ${getSpacingToken(props.spacingToken)}px;
        `}
    ${(props: Props) =>
        props.inline &&
        css`
            display: inline;
        `}
`;
/** @deprecated use stack instead */
export const SpacingSmallTop: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="100" top>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingMediumTop: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="200" top>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingLargeTop: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="300" top>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingMediumBottom: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="200" bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingSemiMediumBottom: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="150" bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingSmallBottom: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="100" bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingSmallTopBottom: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="100" top bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingMediumTopBottom: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="200" top bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingLargeLeft: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="300" left>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingMediumLeft: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="200" left>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingSmallLeft: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="100" left>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingMediumLeftRight: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="200" left right>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingLargeLeftRight: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="300" left right>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingSmallAll: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="100" left right top bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingMediumAll: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="200" left right top bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingLargeAll: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="300" left right top bottom>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingSmallRight: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="100" right>
        {children}
    </Spacing>
);
/** @deprecated use stack instead */
export const SpacingInlineMicroLeft: FCClassnamed = ({ children, className }) => (
    <Spacing className={className} spacingToken="50" left inline>
        {children}
    </Spacing>
);
